import styled from "styled-components";
import PublicSelect from "../../publics/PublicSelect";
import { ShowcaseSelectBoxProps } from "../../../constants/types";
import { SelectChangeEvent } from "@mui/material";
import {
  getSiteSelectList,
  getZoneSelectList,
} from "../../../constants/function";

const ShowcaseSelectBox = (props: ShowcaseSelectBoxProps) => {
  const onChangeSiteNo = (e: SelectChangeEvent) => {
    props.option.setOptions({
      ...props.option.options,
      showcase: {
        ...props.option.options.showcase,
        siteNo: e.target.value,
      },
    });
  };
  const onChangeZoneNo = (e: SelectChangeEvent) => {
    props.option.setOptions({
      ...props.option.options,
      showcase: {
        ...props.option.options.showcase,
        zoneNo: e.target.value,
      },
    });
  };

  return (
    <Container>
      <PublicSelect
        height={100}
        items={getSiteSelectList(props.categories)}
        onChange={onChangeSiteNo}
        value={props.option.options.showcase.siteNo}
        width={30}
        placeholder="프로젝트 선택"
        margin="0 1% 0 0"
        name="siteNo"
        all
      />
      <PublicSelect
        height={100}
        items={getZoneSelectList(
          props.categories,
          props.option.options.showcase.siteNo
        )}
        onChange={onChangeZoneNo}
        value={props.option.options.showcase.zoneNo}
        width={30}
        placeholder="지점 선택"
        name="zoneNo"
        all
      />
    </Container>
  );
};

export default ShowcaseSelectBox;

const Container = styled.div`
  width: 100%;
  height: 5%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;
